import React, { useState } from 'react';
import { DataGrid } from '@material-ui/data-grid';
import Chip from '@material-ui/core/Chip';
import Tooltip from "@material-ui/core/Tooltip";
import Button from '@material-ui/core/Button';
import DeleteIcon from '@mui/icons-material/Delete';

function CompanyListDataGridWithActions({data, delete_url_path} :any) {

  const [listData, setlistData] = useState(data);

  function updatelistAPI(ticker) {
    const url = delete_url_path + ticker;
    const msg = fetch(url, {method: 'DELETE'})
      .then(resp => resp.json)

    return msg;
  }

  function updateList(e, ticker) {
    e.preventDefault();
    const list = listData.filter(i => i.ticker !== ticker)
    updatelistAPI(ticker)
    return setlistData(list);
  }

  const columns = [
    { field: 'id', headerName: 'Ticker', width: 80, sortable: false, renderHeader:(params) => ( <strong>Ticker</strong>), renderCell: (params) => (<a href={"/ticker/" + params.value}><strong>{params.value}</strong></a>)},
    { field: 'company', headerName: 'Company', width: 300, sortable: false, renderHeader:(params) => ( <strong>Company</strong>)},
    { field: 'consideration', headerName: 'Consideration', width: 140, renderHeader:(params) => ( <strong>Consideration</strong>), renderCell: (params) => (params.getValue(params.id, 'recommendationColor') === 'green' ? <Chip label="Buy" color="primary"/> : <Chip label="Avoid" color="secondary"/> )},
    { field: 'decision', headerName: 'Decision', width: 180, renderHeader:(params) => ( <strong>Decision</strong>)},
    { field: 'price', headerName: 'Price', sortable: false,  width: 100, renderHeader:(params) => ( <strong>Price</strong>)},
    { field: 'marginOfSafety', headerName: 'Margin of Safety', sortable: false,  width: 150, renderHeader:(params) => ( <strong>Margin of Safety</strong>)},
    { field: 'valueScore', headerName: 'Value Score', width: 110, renderHeader:(params) => ( <strong>Value Score</strong>)},
    {
      field: 'actions',
      headerName: 'Actions',
      width: 200,
      renderHeader:(params) => (<strong>Actions</strong>),
      renderCell: (params) => {
        return(
          <Button size="small" variant="outlined" onClick={(e) => updateList(e, params.getValue(params.id, 'id')) } >Delete</Button>
        );
      }
     },
    { field: 'recommendationColor', hide: true},
  ]

  function buildCompanyData(item) {
    return {
      id: item.ticker,
      company: item.company,
      consideration: item.default_valuation?.recommendation || "Avoid",
      decision: item.default_valuation?.decision || 'Undetermined',
      price: item.default_valuation?.price_in_words,
      marginOfSafety: item.default_valuation?.margin_of_safety_in_words,
      valueScore: item.value_score,
      recommendationColor: item.default_valuation?.recommendation_color
    }
  }

  const rows = data?.map(item => buildCompanyData(item));

  return (
    <div className="row">
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={30}
        rowsPerPageOptions={[30]}
        autoHeight={true}
        autoPageSize={true}
        density={"compact"}
        disableColumnMenu
        getRowClassName={(params) =>
          (params.getValue(params.id, 'recommendationColor') === 'green' ? 'table-success' : 'table-danger')
        }
      />
    </div>
  );
}

export default CompanyListDataGridWithActions;
